import React from "react";
import {flagUrl} from "../../../utils";
import {useTranslation} from "react-i18next";


type UiFlagType = {
    countryCode: string,
    className?: string,
    showTooltip?: boolean
}

export const UiFlag: React.FC<UiFlagType> = ({
    countryCode,
    className,
    showTooltip = true
}) => {
    const {t} = useTranslation();

    return (
        <div className="group relative z-0">
            <img
                className={(className ? `${className}` : "") + " rounded-md"}
                src={flagUrl(countryCode)}
                alt={`${countryCode} flag`}
                loading="lazy"
            />

            {showTooltip && <span className="group-hover:opacity-100 transition-opacity bg-gray-800 px-2
                text-sm text-gray-100 rounded-md absolute left-1/2 
                -translate-x-1/2 opacity-0 m-4 mx-auto">{t(`countries.${countryCode}`)}</span>}
        </div>
    )
}
